import { PAY_ON_ARRIVAL, PAYPAL, STRIPE } from 'constants/widget';

const getAvailablePaymentsTypes = settingsData => {
  const paymentsTypes = [];

  if (settingsData.stripeSettings) {
    paymentsTypes.push(STRIPE);
  }

  if (settingsData.payPalSettings) {
    paymentsTypes.push(PAYPAL);
  }

  const payOnArrivalPossibility = settingsData.payOnArrivalPossibility;
  if (payOnArrivalPossibility && payOnArrivalPossibility.payOnArrival) {
    paymentsTypes.push(PAY_ON_ARRIVAL);
  }

  return paymentsTypes;
};

export { getAvailablePaymentsTypes };
